import(/* webpackMode: "eager", webpackExports: ["ContactSection"] */ "/vercel/path0/components/sections/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GallerySection"] */ "/vercel/path0/components/sections/gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/components/sections/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesSection"] */ "/vercel/path0/components/sections/services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/vercel/path0/components/sections/testimonials.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
